



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Form } from 'wok-forms';

@Component
export default class SignIn extends Vue {
    @Prop() successRoute: any;
    @Prop() passwordRecoveryRoute: any;
    @Prop() bannerSrc: any;
    @Prop() bannerMobileSrc: any;

    username = '';
    usernameIsValid = false;
    password = '';
    accessError = false;
    showPasswordUpdateMessage = false;

    mounted() {
        this.showPasswordUpdateMessage = this.$store.state.uiMessage == 'password-updated';
        this.$store.commit('clearUIMessage');
    }

    get isMobile() {
        return this.$store.state.isMobile;
    }

    get submitEnabled() {
        return !!this.username && !!this.password && this.usernameIsValid;
    }

    onUsernameValid(valid: boolean) {
        this.usernameIsValid = valid;
    }

    async onSubmit(evt: Event) {
        let form = this.$refs.form as Form;
        let response = await this.$store.dispatch('signIn', { username: this.username, password: this.password });
        if (response.result == "OK") {
            this.$router.push(this.successRoute);
        }
        else {
            this.accessError = true;
        }
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/dndg/access/signin.vue